export default __webpack_public_path__ + "static/media/GR6 2A-1B-2D-1E-3EC.370c9bd7.jpg";